import {
    FontAwesomeIcon,
    FontAwesomeLayers,
    FontAwesomeLayersText,
} from '@fortawesome/vue-fontawesome';
import { AuthService, Firewall, UserDataStore } from '@skinsoft/auth';

import { TranslationDataStore } from '@skinsoft/i18n';
import { BarcodeReader, BarcodeSubscriber, Field, Form, ItemCard, LocalizedDate, LocalizedString } from '@skinsoft/ui';
import BootstrapVue from 'bootstrap-vue';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Router from 'vue-router';
import Toasted from 'vue-toasted';

import {
    AliasDataStore,
    AliasDataStore as CollaboratorDataStore,
    AuditCampaignDataStore,
    ExpressionDataStore,
    InstitutionDataStore,
    ItemDataStore,
    LocationDataStore,
    ManifestationDataStore,
    RecordDataStore,
    ThesaurusDataStore,
    ThesaurusTermDataStore,
    WorkDataStore,
    WorkspaceDataStore
} from '@skinsoft/entity';

import { EntityFieldDataStore } from '@skinsoft/data-store';
import { MediaTransferHelper, ImageTransferHelper } from '@skinsoft/media-transfer-helper';
import { RecordMaskDataStore } from '@skinsoft/record-mask';
import { MaskField } from '@skinsoft/record-mask/src/components/mask-field';
import { MetaRecordMaskDataStore } from '@skinsoft/record-mask/src/meta-record-mask-data-store';

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.component('font-awesome-layers-text', FontAwesomeLayersText);
Vue.component('s-form', Form);
Vue.component('s-field', Field);
Vue.component('s-firewall', Firewall);
Vue.component('s-localized-date', LocalizedDate);
Vue.component('s-localized-string', LocalizedString);
Vue.component('s-mask-field', MaskField)
Vue.component('s-barcode-reader', BarcodeReader)
Vue.component('s-barcode-subscriber', BarcodeSubscriber)
Vue.component('s-item-card', ItemCard)

Vue.use(BootstrapVue);
Vue.use(Router);
Vue.use(Toasted);
Vue.use(AuthService);
Vue.use(VueI18n);

Vue.use(TranslationDataStore);

Vue.use(AliasDataStore);
Vue.use(ThesaurusTermDataStore);
Vue.use(ThesaurusDataStore);
Vue.use(InstitutionDataStore);
Vue.use(EntityFieldDataStore)
Vue.use(UserDataStore)
Vue.use(WorkspaceDataStore)

Vue.use(ItemDataStore);
Vue.use(ManifestationDataStore)
Vue.use(ExpressionDataStore)
Vue.use(WorkDataStore);
Vue.use(LocationDataStore);
Vue.use(EntityFieldDataStore)
Vue.use(CollaboratorDataStore)

Vue.use(AuditCampaignDataStore)
Vue.use(MediaTransferHelper)
Vue.use(ImageTransferHelper)
Vue.use(RecordDataStore)
Vue.use(RecordMaskDataStore)
Vue.use(MetaRecordMaskDataStore)

if(process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'dev') {
    Vue.config.devtools = true;
    Vue.config.productionTip = false;
} else {
    Vue.config.devtools = false;
    Vue.config.productionTip = true;
}
